import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { fetchOk } from '@atlassian/mpac-fetch-wrapper';
import { log } from '@atlassian/mpac-utils';
export const FallbackAmktBootstrap = {
  ldUserKey: 'ANY_USER'
};
export const getAmktBootstrap = async (mpacBaseUrl, headers) => {
  const path = mpacBaseUrl + "/rest/internal/frontend/bootstrap";
  const options = _objectSpread({}, headers && {
    headers
  });
  try {
    const response = await fetchOk(path, options);
    const amktBootstrap = await response.json();
    return amktBootstrap;
  } catch (error) {
    log.error('getAmktBootstrap', 'Failed to fetch bootstrap, using fallback', {
      error
    });
    return _objectSpread({}, FallbackAmktBootstrap);
  }
};